export * from './konstantes';
